import { render, staticRenderFns } from "./ParticleNetwork.vue?vue&type=template&id=86ca05de&"
import script from "./ParticleNetwork.vue?vue&type=script&lang=js&"
export * from "./ParticleNetwork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports